<template>
  <div class="box">
    <!-- 顶部导航 -->
    <NavHeader :title="orderInfo.statementStatus"></NavHeader>
    <div
      :class="`${getClassName} bg-table-header p-a-10  flex-column overflow-auto`"
      ref="scrollContent"
      id="scrollContentId"
      @scroll="scrollContent"
    >
      <div class="bg-table-header p-tb-10">
        <PayCountdown :isScroll="isScroll" v-if="!isPaySuccess" :toCancelSecond="toCancelSecond">
          <template #text>
            <span>
              待支付金额：
              <span class="text-danger font-weight-bold">¥{{ orderInfo.noSettleCurr }}</span>
            </span>
          </template>
          <template #btn>
            <el-button type="warning" round @click="toPayFn">去支付</el-button>
          </template>
        </PayCountdown>
      </div>
      <!-- 待支付卡片 -->
      <!-- <PayCard /> -->

      <!-- 对账单信息 + 汇总表格 -->
      <BillInfo :orderInfo="orderInfo" />

      <!-- 应收单据 -->
      <ReceivableSection :orderInfo="orderInfo" />

      <!-- 商品明细 -->
      <GoodsSection :purchaseNo="orderInfo.purchaseNo" :purchaseId="id" />

      <!-- 支付明细 -->
      <PayDetailSection :purchaseNo="orderInfo.purchaseNo" />
      <!-- 选择支付方式 -->
      <SelectPayMethod
        ref="selectPayRef"
        id="payMethodId"
        class="m-t-10 select_pay"
        :billNo="orderInfo.purchaseNo"
        :billId="Number(id)"
        :query="queryParams"
        :totalAmount="orderInfo.noSettleCurr"
        v-if="!isPaySuccess && orderInfo.purchaseNo"
        @payChange="payChangeFn"
      />
      <div class="m-t-10 bg-white p-tb-20 p-lr-20 flex flex-col-end" v-show="isPaySuccess">
        <div style="width:350px">
          <div class="flex flex-row-center m-b-10">
            <span class="inline-block w-70 text-right m-r-20">对账单号</span>
            <span class="flex1 text-right">
              <span>{{ orderInfo.purchaseNo }}</span> |
              <el-button type="text" @click="copyFn(orderInfo.purchaseNo)">复制</el-button>
            </span>
          </div>
          <div class="flex flex-row-center m-b-10">
            <span class="inline-block w-70 text-right m-r-20">业务期间</span>
            <span class="flex1 text-right">{{ orderInfo.statementPeriod }}</span>
          </div>
          <div class="flex flex-row-center m-b-10">
            <span class="inline-block w-70 text-right m-r-20">支付时间</span>
            <span class="flex1 text-right">{{ orderInfo.payTime }}</span>
          </div>
          <div class="flex flex-row-center m-b-10">
            <span class="inline-block w-70 text-right m-r-20">应付金额</span>
            <span class="flex1 text-right">￥{{ orderInfo.arrearReal }}</span>
          </div>
          <div class="flex flex-row-center">
            <span class="inline-block w-70 text-right m-r-20">已付金额</span>
            <span class="flex1 text-right font-size-20 font-weight-bold text-danger">
              ￥{{ orderInfo.settleCurr }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white p-tb-10 p-lr-10 text-right border-top-1" v-if="!isPaySuccess && payType !== 'lkl-counter'">
      <el-button type="warning" round @click="surePayOrder">
        确定(F7)
      </el-button>
    </div>
  </div>
</template>
<script>
import NavHeader from "./components/NavHeader.vue";
// import PayCard from "./components/PayCard.vue";
import BillInfo from "./components/BillInfo.vue";
import ReceivableSection from "./components/ReceivableSection.vue";
import GoodsSection from "./components/GoodsSection.vue";
import PayDetailSection from "./components/PayDetailSection.vue";
import PayCountdown from "./components/PayCountdown.vue";
import { statementDetails, postPay } from "@/api/reconciliation";
import SelectPayMethod from "./components/SelectPayMethod.vue";
import { scrollToWithOffset } from "../../../../minin/homepage.js";
export default {
  name: "PayReconciliation",
  components: {
    PayCountdown,
    NavHeader,
    // PayCard,
    BillInfo,
    ReceivableSection,
    GoodsSection,
    PayDetailSection,
    SelectPayMethod
  },
  computed: {
    getClassName() {
      if (this.$route.path.includes("/new-products/system-center/wl-reconciliation")) {
        return "";
      } else {
        return "info-content";
      }
    }
  },
  data() {
    return {
      isScroll: false,
      toCancelSecond: true,
      orderInfo: {},
      id: 0,
      queryParams: {},
      isPaySuccess: false, //是否支付成功
      payType: null, //线上支付 lkl-counter 线下支付 financial
      payObj: {} //付款信息
    };
  },
  mounted() {
    const query = this.$route.query;
    console.log("query", query);
    this.id = query.id;
    this.getDetails();
  },
  methods: {
    payChangeFn(val) {
      console.log("888999", val);
      this.payType = val.type;
      this.payObj = val;
    },
    //确认支付（线下支付）
    surePayOrder() {
      const params = {
        billNo: this.orderInfo.purchaseNo,
        billId: Number(this.id),
        payType: this.payType,
        remarks: this.payObj.remarks,
        voucherImages: this.payObj.voucherImages
      };
      if (this.$refs.selectPayRef) {
        const setting = this.$refs.selectPayRef.getSetting();
        if (!setting.financialMustVoucher && !params.voucherImages.length) {
          this.$message.warning("请上传支付凭证！");
          return;
        }
      }
      postPay(params)
        .then(() => {
          this.$message.success("支付确认成功!");
          // this.getDetails();
          let path = "";
          if (this.$route.path.includes("/new-products/system-center/wl-reconciliation")) {
            path = "/new-products/system-center/wl-reconciliation";
          } else {
            path = "/reconciliations/currentReconciliation";
          }
          this.$router.push({
            path: path
          });
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    getDetails() {
      statementDetails(this.id).then(res => {
        console.log("details", res);
        this.orderInfo = res;
        setTimeout(() => {
          this.toPayFn();
        }, 100);
      });
    },
    copyFn(text) {
      this.$copyText(text).then(
        () => {
          this.$message.success("复制成功！");
        },
        () => {
          this.$message.error("复制失败");
        }
      );
    },
    scrollContent(e) {
      console.log(e);
      // if (e.target.scrollTop > 130) {
      //   this.isScroll = true;
      // } else {
      //   this.isScroll = false;
      // }
    },
    toPayFn() {
      // this.$refs.scrollContent.scrollTop = 2000;
      if (this.$route.path.includes("/new-products/system-center/wl-reconciliation")) {
        const targetSection = document.getElementById("payMethodId");
        const parentNode = document.getElementById("scrollContainer");
        if (targetSection && parentNode) {
          // targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
          scrollToWithOffset(targetSection, 100, parentNode);
        }
      } else {
        const targetSection = document.getElementById("payMethodId");
        const parentNode = document.getElementById("scrollContentId");
        if (targetSection && parentNode) {
          targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
          // scrollToWithOffset(targetSection, 100, parentNode);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.box {
  height: 100%;
  overflow-y: scroll;
  .info-content {
    width: 100%;
    height: calc(100% - 50px);
  }
}
</style>
